import { notification } from 'antd'
import axios, { AxiosError, AxiosInstance } from 'axios'
import get from 'lodash/get'

import { clearAuthStorage } from 'utils/authStorage'

function showNotification(error: AxiosError) {
  const { method } = error.config

  const isSendMethod = ['post', 'put'].includes(method)

  function show() {
    notification.error({
      message: 'Error!',
      description: error?.response?.data?.message || error.message,
    })
  }

  /*
   if post or put method, isShowNotificationError must set to true to show notification error
   */
  if (isSendMethod && error.config?.isShowNotificationError === true) {
    show()
    return
  }

  /*
  if the method other than post and put for ex: like get method and
  isShowNotificationError must set to false to hide notification error
   */
  if (!isSendMethod && error.config?.isShowNotificationError !== false) {
    show()
  }
}

function createAuthAxios(
  baseURL: string,
  keyLocalStorage?: string,
): AxiosInstance {
  const instanceAxios = axios.create({
    baseURL,
  })

  if (keyLocalStorage) {
    instanceAxios.interceptors.request.use((config) => {
      const curConfig = { ...config }

      // ALWAYS READ UPDATED TOKEN
      if (typeof window !== 'undefined') {
        curConfig.headers['Authorization'] = `Bearer ${localStorage.getItem(
          keyLocalStorage,
        )}`
      }
      return curConfig
    })
  }

  instanceAxios.interceptors.response.use(
    (response) => {
      return response
    },
    (error: AxiosError) => {
      showNotification(error)

      const status = get(error, 'response.data.code', null)

      if (status === 401) {
        clearAuthStorage()

        notification.error({
          message: 'Gagal',
          description: 'Sesi anda berakhir, silakan login kembali.',
        })

        window.location.replace('/')

        window.location.reload()

        return Promise.reject(error)
      }

      // const status = get(error, 'response.status', null)
      // if (status === 401) {
      //   window.localStorage.removeItem('tokenpublic')
      //   Router.replace('/').then(() => {
      //     window.location.reload()
      //   })
      //   return Promise.reject(error)
      // }
      //
      // notification.error({
      //   message: error.message,
      //   description: get(error, 'response.data.message', '-'),
      // })
      return Promise.reject(error)
    },
  )

  return instanceAxios
}

const Fetcher = {
  createAuthAxios,
}

export default Fetcher
